import React from 'react';

export type AddressMultilineProps = {
  address: {
    line1?: Maybe<string>;
    line2?: Maybe<string>;
    city?: Maybe<string>;
    state?: Maybe<string>;
    country?: Maybe<string>;
    postalCode?: Maybe<string>;
  };
};

export const AddressMultiline = ({ address }: AddressMultilineProps) => {
  const { line1, line2, city, state, country, postalCode } = address;
  return (
    <>
      {line1}
      {line2 && (
        <>
          <br />
          {line2}
        </>
      )}
      <br />
      {city}, {state} {postalCode}
      <br />
      {country}
    </>
  );
};
